module.exports = __webpack_public_path__ + "static/media/kid5.115caf1b.png";